<template>
  <div>
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/walletindex' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>钱包</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/wallet/old' }">旧资金账户</el-breadcrumb-item>
      <el-breadcrumb-item>电子账户信息</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="segment-outer">
      <div class="segment statistics">
        <div class="segment-header">电子账户信息</div>
        <div class="segment-area segment-item-box">
          <div class="segment-item">
            <span class="name">电子账户名：</span>
            <span class="dec" id="auto-0">{{ accountInfo.eacctName }}</span>
          </div>
          <div class="segment-item">
            <span class="name">电子账户号：</span>
            <span class="dec" id="auto-1">{{ accountInfo.eacctNo }}</span>
          </div>
          <div class="segment-item">
            <span class="name">开户行：</span>
            <span class="dec" id="auto-2">{{ accountInfo.payBankName }}</span>
          </div>
          <div class="segment-item">
            <span class="name">总账户信息：</span>
            <span class="dec" id="auto-3" v-if="accountInfo.masterAccountName"
              >{{ accountInfo.masterAccountName }}({{ accountInfo.masterAccountNo }})</span
            >
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="ml-20 mt-20">
      <el-button type="primary" id="auto-4" @click="handleBack">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/wallet.new.api';
export default {
  name: 'WalletAccount',
  data() {
    return {
      chlType: '',
      taxChlType: '',
      taxCompanyId: '',
      accountInfo: {
        eacctName: '',
        eacctNo: '',
        payBankName: '',
        masterAccountName: '',
        masterAccountNo: ''
      }
    };
  },
  created() {
    this.chlType = this.$route.params.chlType;
    this.taxChlType = this.$route.params.taxChlType;
    this.taxCompanyId = this.$route.params.taxCompanyId || '';
    this.queryAccountInfo();
  },
  methods: {
    // 查询账户信息
    queryAccountInfo() {
      axios
        .post(api.eaccountInfo, {
          chlType: this.chlType,
          taxChlType: this.taxChlType,
          taxCompanyId: this.taxCompanyId
        })
        .then(res => {
          this.accountInfo = res.data;
        });
    },
    handleBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.segment-item-box {
  margin: 40px 20px;
}
.segment-item {
  display: flex;
  margin: 20px 0;
}
.segment-item .name {
  width: 164px;
  color: #90a0b1;
}
.segment-item .name.short {
  width: 100px;
}
.download {
  display: inline-block;
  margin-bottom: 10px;
}
.segment-item .dec {
  color: #424b53;
}
</style>
